import React from 'react';
import PropTypes from 'prop-types';
import { setTrackDataLayer } from '../../utils/index';

const Pagination = ({
  currentPage,
  totalPages,
  onNavigate,
  resultsPerPage,
  resultsListing,
  tab,
  selectedTab
}) => {
  const pagesArr = [];

  const handleGoogleAnalytics = () => {
    if (!tab && !selectedTab) return;

    if (tab.value === selectedTab.value) {
      const gaItems = resultsListing.map(item => item.gaModel);

      setTrackDataLayer({
        eventName: 'view_item_list',
        custom: {
          ecommerce: {
            items: gaItems
          }
        }
      });
    }
  };

  for (let i = 0; i < totalPages; i++) {
    pagesArr.push(
      <li key={i + 1}>
        <span
          className={i + 1 === currentPage ? 'current' : ''}
          onClick={() => {
            onNavigate(i + 1);
            handleGoogleAnalytics();
          }}
        >
          {i + 1}
        </span>
      </li>
    );
  }

  const CurrentPage = () => {
    return (
      <>
        <li>
          <span
            className="current"
            onClick={() => {
              onNavigate(currentPage);
              handleGoogleAnalytics();
            }}
          >
            {currentPage}
          </span>
        </li>
      </>
    );
  };

  const InnerPagination = () => {
    return (
      <>
        {currentPage === totalPages && (
          <li>
            <span
              onClick={() => {
                onNavigate(totalPages - 2);
                handleGoogleAnalytics();
              }}
            >
              {totalPages - 2}
            </span>
          </li>
        )}
        {currentPage >= 3 && (
          <li>
            <span
              onClick={() => {
                onNavigate(currentPage - 1);
                handleGoogleAnalytics();
              }}
            >
              {currentPage - 1}
            </span>
          </li>
        )}
        <CurrentPage />
        {currentPage <= totalPages - 2 && (
          <li>
            <span
              onClick={() => {
                onNavigate(currentPage + 1);
                handleGoogleAnalytics();
              }}
            >
              {currentPage + 1}
            </span>
          </li>
        )}
        {currentPage === 1 && (
          <li>
            <span
              onClick={() => {
                onNavigate(currentPage + 2);
                handleGoogleAnalytics();
              }}
            >
              {currentPage + 2}
            </span>
          </li>
        )}
      </>
    );
  };

  const PaginationEllipsis = () => {
    return (
      <>
        {currentPage > 1 && (
          <li className="first-page">
            <span
              href={1}
              onClick={() => {
                onNavigate(1);
                handleGoogleAnalytics();
              }}
            >
              {1}
            </span>
          </li>
        )}
        {currentPage > 3 && <li className="ellipsis">...</li>}
        <InnerPagination />
        {currentPage <= totalPages - 3 && <li className="ellipsis">...</li>}
        {currentPage < totalPages && (
          <li className="last-page">
            <span
              onClick={() => {
                onNavigate(totalPages);
                handleGoogleAnalytics();
              }}
            >
              {totalPages}
            </span>
          </li>
        )}
      </>
    );
  };

  return (
    <div className="pagination">
      {resultsPerPage && (
        <div className="pagination__pagination-inner">
          {pagesArr.length > 5 && (
            <button
              className="pagination-btn pagination--prev"
              role="button"
              type="button"
              aria-label="Previous page"
              onClick={() => {
                onNavigate(currentPage - 1);
                handleGoogleAnalytics();
              }}
              disabled={currentPage === 1}
            >
              <svg viewBox="0 0 11 11" className="pagination__link-arrow">
                <use xlinkHref="#chevron-right" />
              </svg>
            </button>
          )}
          {totalPages > 1 && (
            <ul className="pagination-pages">
              {pagesArr.length <= 5 ? pagesArr : <PaginationEllipsis />}
            </ul>
          )}
          {totalPages > 5 && (
            <button
              className="pagination-btn pagination--next"
              role="button"
              type="button"
              aria-label="Next page"
              onClick={() => {
                onNavigate(currentPage + 1);
                handleGoogleAnalytics();
              }}
              disabled={currentPage === totalPages}
            >
              <svg viewBox="0 0 11 11" className="pagination__link-arrow">
                <use xlinkHref="#chevron-right" />
              </svg>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onNavigate: PropTypes.func.isRequired,
  resultsListing: PropTypes.array.isRequired,
  tab: PropTypes.object,
  selectedTab: PropTypes.object
};

export default Pagination;
